import { createApiAction } from 'src/api';
import { IMPERSONATE_ACCOUNT } from 'src/user/redux/actions';

export const SIGN_IN_START = 'auth/sign_in_start';
export const SIGN_IN_SUCCESS = 'auth/sign_in_success';
export const SIGN_IN_FAILURE = 'auth/sign_in_failure';
export const CLEAR_AUTH_ERRORS = 'auth/clear_auth_errors';
export const SIGN_OUT = 'auth/SIGN_OUT';

export const signIn = ({ email, password }) =>
  createApiAction(
    {
      path: '/api/v1/auth/jwt-token/',
      method: 'POST',
      body: { user_email_address: email, password },
    },
    [
      SIGN_IN_START,
      {
        type: SIGN_IN_SUCCESS,
        payload: (action, state, res) => {
          return res.json().then(data => {
            // console.log('Sign in response data:', data);

            // Check for 2FA response
            if (data.code === '2fa_required') {
              // console.log('2FA required detected in response');

              // Add a flag to identify this as a 2FA response
              return {
                ...data,
                email: data.email || email,
                is2faRequired: true,
                // Don't include token properties - this is important!
                access: null,
                refresh: null,
              };
            }

            return data;
          });
        },
      },
      {
        type: SIGN_IN_FAILURE,
        payload: (action, state, res) => {
          // console.log('Sign in failure:', res);
          // Try to parse the error response
          return res.json().then(
            data => ({ ...data, status: res.status }),
            () => ({ detail: 'Unknown error', status: res.status })
          );
        },
      },
    ]
  );

export function signOut() {
  return dispatch => {
    dispatch({
      type: SIGN_OUT,
    });
  };
}
// Make sure to export the function
export const isAuthenticated = state => {
  // Add debugging
  // console.log('Checking authentication state:', state.auth.token.data);

  // Don't consider a user authenticated if we're in 2FA flow
  if (state.auth.token.data && state.auth.token.data.is2faRequired) {
    // console.log('User in 2FA flow, not authenticated');
    return false;
  }

  // Normal auth check
  const isAuth =
    state.auth.token.data &&
    state.auth.token.data.access &&
    state.auth.token.data.refresh;

  // console.log('Authentication check result:', isAuth);
  return isAuth;
};

export function clearAuthErrors() {
  return dispatch => {
    dispatch({
      type: CLEAR_AUTH_ERRORS,
    });
  };
}

export function setSelectedAccount(accountId) {
  return dispatch => {
    dispatch({
      type: IMPERSONATE_ACCOUNT,
      payload: {
        accountId,
      },
    });
  };
}
